import { clsx } from "@regrello/core-utils";
import type React from "react";

import type { RegrelloIntent } from "../../../tokens/enums/regrelloIntent";

export function RegrelloMenuShortcut({
  className,
  intent,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & { intent?: RegrelloIntent }) {
  return (
    <span
      className={clsx(
        "text-sm",
        {
          "text-neutral-textMuted": intent === "neutral",
          "text-primary-textMuted": intent === "primary",
          "text-success-textMuted": intent === "success",
          "text-warning-textMuted": intent === "warning",
          "text-danger-textMuted": intent === "danger",
        },
        className,
      )}
      {...props}
    />
  );
}
